import React from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { getLayersAction, setCurrentLayerAction } from 'store/actions/layers';
import { resetDynamicSeries } from 'store/actions/dynamicSeries';
import { YearSelect } from 'components/UI/YearSelect';
import { AteBlock } from 'components/UI/AteBlock';
import { SelectChangeEvent } from '@mui/material';

export const LayersSelect: React.FC = (): JSX.Element => {
  const { years, currentYear } = useAppSelector((state) => state.layers);
  const { isLogged } = useAppSelector((state) => state.mainPage);
  const dispatch = useAppDispatch();

  const handleChangeYear = (event: SelectChangeEvent) => {
    const year = event.target.value;
    dispatch(getLayersAction(isLogged, year));
    dispatch(setCurrentLayerAction('', '', 0, '', '', ''));
    dispatch(resetDynamicSeries());
  };

  return (
    <>
      <YearSelect
        years={years}
        currentYear={currentYear}
        handleChangeYear={handleChangeYear}
      />
      <AteBlock />
    </>
  );
};
